// dateUtils.js

import getFortnightStartDate from '../services/DateService';
import DateService from '../services/DateService';


export async function getFortnightDates() {
  try {
    // Fetch the start date from the server using DateService API
    const response = await DateService.getFortnightStartDate();
    const start_date = response.fortnights[0].start_date;
    const startDate = new Date(start_date);
    // Calculate the other dates based on the fetched start date
    const firstWeekStart = new Date(startDate);
    const firstWeekEnd = new Date(firstWeekStart);
    const secondWeekStart = new Date(firstWeekStart);
    const secondWeekEnd = new Date(firstWeekStart);
    const thirdWeekStart = new Date(firstWeekStart);
    const thirdWeekEnd = new Date(firstWeekStart);

    firstWeekEnd.setDate(firstWeekStart.getDate() + 6);
    secondWeekStart.setDate(firstWeekStart.getDate() + 7);
    secondWeekEnd.setDate(firstWeekStart.getDate() + 13);
    thirdWeekStart.setDate(firstWeekStart.getDate() + 14);
    thirdWeekEnd.setDate(firstWeekStart.getDate() + 20);

    return {
      firstWeekStart,
      firstWeekEnd,
      secondWeekStart,
      secondWeekEnd,
      thirdWeekStart,
      thirdWeekEnd,
    };
  } catch (error) {
    // Handle errors (e.g., log or throw an error)
    console.error('Error fetching fortnight start date:', error.name);
    throw error;
  }
}

export function formatDate(date) {
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
  const day = String(formattedDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatReadableDate(date) {
  const formattedDate = new Date(date);
  const year = formattedDate.getFullYear();
  const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
  const day = String(formattedDate.getDate()).padStart(2, '0');
  return `${formattedDate.toLocaleDateString('en-AU', { weekday: 'short' })} ${formattedDate.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })}`;
}

  export function determineCurrentWeek(fortnightDates) {
    const now = new Date();
    const { firstWeekStart, firstWeekEnd, secondWeekStart, secondWeekEnd, thirdWeekStart, thirdWeekEnd } = fortnightDates;

    // Helper function to reset time to midnight (00:00:00) for comparison
    const resetTime = (date) => {
      const resetDate = new Date(date);
      resetDate.setHours(0, 0, 0, 0);
      return resetDate;
    };

    const nowDate = resetTime(now);
    const firstStart = resetTime(new Date(firstWeekStart));
    const firstEnd = resetTime(new Date(firstWeekEnd));
    const secondStart = resetTime(new Date(secondWeekStart));
    const secondEnd = resetTime(new Date(secondWeekEnd));
    const thirdStart = resetTime(new Date(thirdWeekStart));
    const thirdEnd = resetTime(new Date(thirdWeekEnd));

    if (nowDate >= firstStart && nowDate <= firstEnd) {
      return 'first';
    } else if (nowDate >= secondStart && nowDate <= secondEnd) {
      return 'second';
    } else if (nowDate >= thirdStart && nowDate <= thirdEnd) {
      return 'third';
    }

    return 'future';
  }


// TODO: review all the below and see if they can be replaced with the above

export function getNextThursday() {
  const now = new Date();
  const nextThursday = new Date(now);

  // Calculate the next Wednesday
  nextThursday.setDate(nextThursday.getDate() + ((4 + 7 - nextThursday.getDay()) % 7));

  // Format the date as "9th April, 2023"
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = nextThursday.toLocaleDateString('en-US', options);

  return formattedDate;
}

export function getLastThursday() {
  const now = new Date();
  const lastThursday = new Date(now);

  // Calculate the last Thursday
  lastThursday.setDate(lastThursday.getDate() + ((4 - 7 - lastThursday.getDay()) % 7));

  // Format the date as "9th April, 2023"
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = lastThursday.toLocaleDateString('en-US', options);


  return formattedDate;
}

export function getNextThreeWeeksDates() {
  // Get the date of last Thursday
  const today = new Date();
  const lastThursday = new Date(today);
  lastThursday.setDate(today.getDate() - ((today.getDay() + 3) % 7));

  // Calculate the dates for the next three weeks (current week, next week, week after next)
  const dates = [lastThursday];
  for (let i = 0; i < 2; i++) {
    const nextWeek = new Date(dates[i]);
    nextWeek.setDate(dates[i].getDate() + 7);
    dates.push(nextWeek);
  }

  // Return the dates for the next three weeks
  return dates;
}

export function formatShortDateRange(startDate, endDate) {
  // Convert to Date objects if they aren't already
  const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;

  // Check if the dates are in the same year as the current year
  const currentYear = new Date().getFullYear();
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
    
  // Only show year if either date is not in the current year
  const showYear = startYear !== currentYear || endYear !== currentYear;

  return `${start.toLocaleDateString(
    'en-AU', { weekday: 'short' }
  )} ${start.toLocaleDateString(
    'en-AU', { day: 'numeric', month: 'short' }
  )}${showYear ? ` ${startYear}` : ''} - ${end.toLocaleDateString(
    'en-AU', { weekday: 'short' }
  )} ${end.toLocaleDateString(
    'en-AU', { day: 'numeric', month: 'short' }
  )}${showYear ? ` ${endYear}` : ''}`;
}

// NEW: Parse a YYYY-MM-DD string as a local date (no timezone shift)
export function parseDateOnly(value) {
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  if (typeof value === 'string') {
    // Expect format YYYY-MM-DD; fall back to native Date if not matched
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const [, y, m, d] = match;
      return new Date(Number(y), Number(m) - 1, Number(d));
    }
    // Fallback (may introduce TZ effects for non-YYYY-MM-DD strings)
    const dt = new Date(value);
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  }
  const dt = new Date(value);
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
}

// NEW: Compare two dates on YYYY-MM-DD (local) basis
export function isSameYMD(a, b) {
  return formatDate(parseDateOnly(a)) === formatDate(parseDateOnly(b));
}

// Calculate period dates for tracking section
export function calculatePeriodDates(periodType, fortnightDates) {
  const { firstWeekStart, firstWeekEnd, secondWeekStart, secondWeekEnd } = fortnightDates;
  
  switch (periodType) {
    case 'current-week':
      // Determine which week we're currently in
      const currentWeek = determineCurrentWeek(fortnightDates);
      if (currentWeek === 'first') {
        return {
          start: firstWeekStart,
          end: firstWeekEnd,
          label: 'Current Week',
          description: 'This week\'s transactions',
          isCurrentWeek: 'first'
        };
      } else if (currentWeek === 'second') {
        return {
          start: secondWeekStart,
          end: secondWeekEnd,
          label: 'Current Week',
          description: 'This week\'s transactions',
          isCurrentWeek: 'second'
        };
      } else {
        // Default to current calendar week if outside fortnight
        const now = new Date();
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay());
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        return {
          start: startOfWeek,
          end: endOfWeek,
          label: 'Current Week',
          description: 'This week\'s transactions',
          isCurrentWeek: 'calendar'
        };
      }
    
    case 'current-fortnight':
      return {
        start: firstWeekStart,
        end: secondWeekEnd,
        label: 'Current Fortnight',
        description: 'Based on the fortnightStartDate managed in settings'
      };
    
    case 'two-weeks':
      // Two weeks = current week + next week (regardless of fortnight cycle)
      // Determine which week we're currently in within the fortnight
      const currentWeekPosition = determineCurrentWeek(fortnightDates);
      let twoWeeksStart, twoWeeksEnd;
      
      if (currentWeekPosition === 'first') {
        // We're in first week of fortnight, so two weeks = first + second week of fortnight
        twoWeeksStart = firstWeekStart;
        twoWeeksEnd = secondWeekEnd;
      } else if (currentWeekPosition === 'second') {
        // We're in second week of fortnight, so two weeks = second week + third week
        twoWeeksStart = secondWeekStart;
        twoWeeksEnd = new Date(secondWeekStart);
        twoWeeksEnd.setDate(secondWeekStart.getDate() + 13); // 14 days total (second week + next week)
      } else {
        // Outside fortnight cycle, calculate based on current calendar week
        const now = new Date();
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay());
        const endOfTwoWeeks = new Date(startOfWeek);
        endOfTwoWeeks.setDate(startOfWeek.getDate() + 13);
        twoWeeksStart = startOfWeek;
        twoWeeksEnd = endOfTwoWeeks;
      }
      
      return {
        start: twoWeeksStart,
        end: twoWeeksEnd,
        label: 'Two Weeks',
        description: 'Two weeks from and including the current week'
      };
    
    case 'three-weeks':
      const threeWeeksEnd = new Date(firstWeekStart);
      threeWeeksEnd.setDate(firstWeekStart.getDate() + 20); // 21 days total
      return {
        start: firstWeekStart,
        end: threeWeeksEnd,
        label: 'Three Weeks',
        description: 'Three weeks from and including the current week'
      };
    
    case 'four-weeks':
      const fourWeeksEnd = new Date(firstWeekStart);
      fourWeeksEnd.setDate(firstWeekStart.getDate() + 27); // 28 days total
      return {
        start: firstWeekStart,
        end: fourWeeksEnd,
        label: 'Four Weeks',
        description: 'Four weeks from and including the current week'
      };
    
    default:
      return calculatePeriodDates('current-week', fortnightDates);
  }
}